import protectionDevicesMap from '../Constants/devices-categories-map';
import _ from 'lodash';
import moment from 'moment';
import { ADD_ONS_CATEGORY, appointmentStatusesIds, appointmentStatusesTitles, DEFAULT_CATEGORY, DISCOUNT_VALUE_TYPES, pastAppointmentStatusesIds, paymentMethods, PRICE_VALUE_TYPES_IDS} from '../Constants/utils';
import { Appointment } from 'src/Models/Appointment';
import { Slot } from '../Models/TimeSlot';
import { devicesIds } from '../Constants/utils'
import formatters from '../Services/formatters.js';
import cookies from './cookies.js';
import qs from 'qs';
import { Device } from '../Models/Device';
import config from '../config.js';
import apptCancellation from './appt-cancellation';
import { Selection } from 'src/Models/Cancel';
import History from '../Services/History';

export default {
	isUserAutenticated,
	getCookieByName,
	scrollChatIntoView,
	scrollToTop,
	createPostMessage,
	convertToMask,
	buildProtectionDevicesByCategory,
	getTotalPrice,
	timeAndDateFormat,
	categorizeAppointments,
	getFirstEnabledTimeSlot,
	isContainBigAssFansDevice,
	getPaymentMethod,
	isApptValidForCnacel,
	portalLogout,
	convertStfSlots,
	verifyRescheduleResponse,
	generateDateAndTimeText,
	deleteCookieByName,
	findBenefit,
	getDiscountValueToShow,
	mobileCheck,
	replaceUuidWithText,
	getValueFromQuery,
	getPlanDefaultBenefit, 
	isContainHisenseDevice,
	getReCaptchaToken,
	getApptStatusTitle, 
	pushCancellationNextRoute
};
function getCookieByName (name: any) {
	let _Cookies = null;
	let result = '';
	try {
		_Cookies = document.cookie.split(';').map(a => a.trim());
		_Cookies.forEach(cook => {
			const parts = cook.split('=');
			const key = parts[0];
			const value = parts[1];
			if (key === name) result = value;
		});
	} catch (e) {
		// nothing
	}

	return result;
}

function deleteCookieByName(name: string) {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}

function isUserAutenticated () {
	return true;
}


function scrollChatIntoView () {
	document.getElementById('chat-messages-ancor')?.scrollIntoView({behavior: 'smooth'});
}

function scrollToTop() {
	window.scrollTo(0, 0);
}

function convertToMask(phone: any){
    const x = phone.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
	return '(' + x[1] + ') ' + x[2] + '-' + x[3];
}

function createPostMessage (messageName: string, payload: any) {
	try {
		window.parent.postMessage(messageName, payload);
	} catch (error) {
		// nothing
	}
	try {
		// window.parent2 && window.parent2.postMessage(messageName, payload);
	} catch (error) {
		// nothing
	}
}

function buildProtectionDevicesByCategory(allDevices: any){
	const { devices, addOnsDevices } = allDevices;
	const devicesUniqMap = devices.reduce((acc: any, next: Device) => {
		acc[next.device_id] = next;
		return acc;
	}, {});

	protectionDevicesMap.forEach((category) => {
		category.devices.forEach((dev: any) => {
			if(!devicesUniqMap[dev]) return;
			devicesUniqMap[dev].category = category.title;
		});
	})

	_.values(devicesUniqMap).filter((dev: any) => !dev.category).forEach((dev: any) => {
		devicesUniqMap[dev.device_id].category = DEFAULT_CATEGORY;
	})
	const allDevicesCategories = _.groupBy(devicesUniqMap, "category");
	if(addOnsDevices.length) allDevicesCategories[ADD_ONS_CATEGORY] = addOnsDevices;
	return allDevicesCategories;
}

function getTotalPrice(price: number, tax: number) {
	return (price + tax).toFixed(2);
}

function timeAndDateFormat(start_time: number, time_duration: number, date: string) {
	const time =  formatters.timeSlot(start_time, time_duration);
	const formattedDate = moment(date).format('MMM D, yyyy');
	return {time, formattedDate};
}
function categorizeAppointments(appointments: Appointment[]) {
	const categoriezed: any = {
		open: [],
		past: []
	};
	appointments.forEach((appt: Appointment) => pastAppointmentStatusesIds.includes(appt.status.id) ? categoriezed.past.push(appt) : categoriezed.open.push(appt))
	return categoriezed;
}
function getFirstEnabledTimeSlot(slots: Slot[]) {
	return (slots.filter((slot) => slot.is_enabled))[0]
}

function isContainHisenseDevice(devices: any) {
	const hisenseDevicesMap = devicesIds.HISENSE.reduce((acc, next) => {
		return {...acc, [next]: true}
	}, {})
	return devices.some((device: any) => hisenseDevicesMap[device.device_id])
}

function isContainBigAssFansDevice(devices: any) {
	return devices.some((device: any) => device.device_id === devicesIds.BAF);
}

function getPaymentMethod(payment: any) { 
	switch(payment.payment_method){
		case paymentMethods.CREDIT_CARD:
			return `${payment.card_type} **** **** **** ${payment.last_digits}`;
		case paymentMethods.PAYPAL: 
			return 'Paypal';
		default: 
			return payment.payment_method
	}
}
function convertStfSlots(slots: any) {
	const dates: any = [];
	let allSlots: Slot[] = [];
	const timeslotsMap = slots.reduce((acc: any, timeSlot: any) => {
		if(!acc[timeSlot.date]) {
			dates.push(timeSlot.date);
			acc[timeSlot.date] = []
		}
		const formattedSlots = timeSlot.slots.reduce((acc: any, slot: number) => {
			const timeName =  formatters.timeSlot(slot);
			acc.push({
				date: timeSlot.date,
				start_time: slot,
				time_slot_name: timeName,
				is_enabled: true,
				withStf: true
			})
			return acc;
		}, [])
		acc[timeSlot.date] = formattedSlots;
		allSlots = allSlots.concat(formattedSlots);
		return acc;
	}, {});
	return {
		slotsMap: timeslotsMap,
		dates,
		slots: allSlots
	}
}
function verifyRescheduleResponse(res: any, withStf: boolean, isMultipleSelection: boolean) {
	return (withStf || isMultipleSelection) ? res.is_succeeded : res.appointment_uuid;
}

function isApptValidForCnacel(statusId: number, isAfterStartTime: boolean) {
	const { SUPPORTED, ASSIGNED, NEW } = appointmentStatusesIds;
	return !isAfterStartTime && ([SUPPORTED, ASSIGNED, NEW].includes(statusId));
}

function portalLogout() {
	cookies.CookieHandler.set('user_access_token', '', moment('01-01-1970'));
 	window.location.href = '/'
}

function generateDateAndTimeText(dateString: string, timeSlotName: string) {
	const formattedDate = moment(dateString).format('MMMM DD, YYYY');
    return `${formattedDate} between ${timeSlotName}`
}

function findBenefit(benefits: any[], id: number) {
	return benefits.find((benefit: any) => benefit.id === id);
}

function getDiscountValueToShow(discount: any, overrideCases?: any) {
    const { value_type, value } = discount;
        const parsedDiscount = parseInt(value);
        const { PERCENTAGE, USD } = DISCOUNT_VALUE_TYPES;

        const renderPrencentage = () => `${parsedDiscount}%`
        const renderDollar = () => `$${parsedDiscount}`

        const funcMaps = {
            [PERCENTAGE]: renderPrencentage,
            [USD]: renderDollar
        }

        const defaultCases = {
            1: [PERCENTAGE],
            2: [USD]
        }

        const cases = overrideCases || defaultCases;
        if(value_type in cases) {
            return funcMaps[cases[value_type]]()
        } else {
            return 'N/A'
        }
}

function mobileCheck() {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
	return check;
};

function replaceUuidWithText(pathname: string) {
	const reg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[\-]*)([a-z0-9\-]+)$/;
	const splittedPath = pathname.split('/');
	splittedPath.forEach((slice: string, index: number) => {
		if(reg.test(slice)) {
			splittedPath[index] = ':uuid'
		}
	})
	return splittedPath.join('/');
}

function getValueFromQuery(key: string) {
	return qs.parse(window.location.search, {
		ignoreQueryPrefix: true
	})[key];
}

function getPlanDefaultBenefit(benefits: any) {
	let benefit = benefits.filter((benefit: any) => benefit.value_type === PRICE_VALUE_TYPES_IDS.PERCENTAGES).find((benefit: any) => benefit.is_default);
	if(!benefit) benefit = { value: 15 };
	return benefit;
}

function getReCaptchaToken(action: any) {
	return new Promise((resolve, reject) => {
		const w:any = window;
		const { grecaptcha } = w;
		grecaptcha.enterprise.ready(async () => {
			const token = await grecaptcha.enterprise.execute(config.googleReCaptchaKey(), {action});
			resolve(token);
		});
	})
}

function getApptStatusTitle(apptStatus: any) {
	if(!apptStatus) return;
	return appointmentStatusesTitles[apptStatus.id] || apptStatus.title;
}

function pushCancellationNextRoute(selection?: Selection) {
	apptCancellation.nextRoute(selection).then((route: string) => {
		History.history.push(route);
	}).catch(e => {
		console.log(e)
	})
}